import React, { useState, useEffect } from "react";
import { MdUpload } from "react-icons/md";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { EditTestimonialContentApi } from "Services/allApi";
import { TestimonialContentApi } from "Services/allApi";


const TestimonialContent = () => {
    const [formData, setFormData] = useState({
        heading: "",
        bg_img: "",
        head_sec1: "",
        head_sec2: "",
        head_sec3: "",
        description: "",
      });
      const [currentImages, setCurrentImages] = useState({
        bg_img: ""
      });
    
      const [id, setId] = useState(null);
    
    
      useEffect(() => {
        
        fetchData();
      }, []);
    
      const fetchData = async () => {
        try {
          const response = await TestimonialContentApi(); // Replace with actual API call
          if (response && !response.error) {
            const data = response.data; // Assuming response is a single object
            setId(data.id);
            setFormData({
              heading: data.heading || "",
              bg_img: "",
              head_sec1: data.head_sec1 || "",
              head_sec2: data.head_sec2 || "",
              head_sec3: data.head_sec3 || "",
              description: data.description || "",
            });
            setCurrentImages({
                bg_img: data.bg_img || "",

            });
          } else {
            toast.error("Error fetching about content data.");
          }
        } catch (error) {
          console.error("Error fetching about content:", error);
          toast.error("Failed to fetch about content!");
        }
      };
    
      const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
          // Validate file type (check if it's an image)
          if (!file.type.startsWith("image/")) {
            alert("Please upload a valid image file.");
            return;
          }
    
          const reader = new FileReader();
          reader.onloadend = () => {
            setFormData({
              ...formData,
              [e.target.id]: file,
            });
            setCurrentImages({
              ...currentImages,
              [e.target.id]: reader.result,
            });
          };
          reader.readAsDataURL(file);
        }
      };
    
    
      const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
          ...prevData,
          [name]: value,
        }));
      };
    
      const handleUpdate = async () => {
        const form = new FormData();
        Object.keys(formData).forEach((key) => {
          if (formData[key]) {
            form.append(key, formData[key]);
          }
        });    
    
        try {
          const response = await EditTestimonialContentApi(1, form);
          toast.success("Updated successfully!");
          console.log("Updated data:", response.data);
        } catch (error) {
          toast.error("Failed to update. Please try again.");
        }
      };
  return (
    <>
        <div>
        <div className="max-w-6xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-3  dark:!bg-navy-700 dark:text-white">
          <h2 className="text-center text-3xl font-bold mb-5 mt-2">Testimonial page Content</h2>
          <hr className="mb-4" />
          <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-4 mt-5">
            {/* Image Uploads */}
            {/* bg_img*/}
            <div className="sm:col-span-4 flex flex-col sm:flex-row items-center sm:justify-between mt-4">
              <div className="sm:w-1/2 flex justify-center mb-4 sm:mb-0">
                {currentImages.bg_img && (
                  <img
                    src={currentImages.bg_img}
                    alt="Current Background Image"
                    className="rounded shadow-md"
                    style={{ height: "130px", width: "150px" }}
                  />
                )}
              </div>
              <div className="sm:w-1/2 text-center">
                <label htmlFor="bg_img" className="block font-medium text-gray-900 mb-2">
                  image
                </label>
                <input
                  type="file"
                  id="bg_img"
                  accept="image/*"
                  className="hidden"
                  onChange={handleImageUpload}
                />
                <button
                  type="button"
                  onClick={() => document.getElementById("bg_img").click()}
                  className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700"
                >
                  <MdUpload />
                </button>
              </div>
            </div>

 {/*heading */}
 <div className="sm:col-span-2">
              <label htmlFor="heading" className="block font-medium text-gray-900">Heading</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="heading"
                  id="heading"
                  value={formData.heading}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
    
         
            {/*head_sec1 */}
            <div className="sm:col-span-2">
              <label htmlFor="head_sec1" className="block font-medium text-gray-900">head_sec1</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="head_sec1"
                  id="head_sec1"
                  value={formData.head_sec1}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/*head_sec2*/}
            <div className="sm:col-span-2">
              <label htmlFor="head_sec2" className="block font-medium text-gray-900">
              head_sec2</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="head_sec2"
                  id="head_sec2"
                  value={formData.head_sec2}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

             {/*head_sec3*/}
             <div className="sm:col-span-2">
              <label htmlFor="head_sec3" className="block font-medium text-gray-900">
              head_sec3</label>
              <div className="mt-2">
                <input
                  type="text"
                  name="head_sec3"
                  id="head_sec3"
                  value={formData.head_sec3}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>

            {/*Bottom Description */}
            <div className="sm:col-span-4">
              <label htmlFor="description" className="block font-medium text-gray-900">Description</label>
              <div className="mt-2">
                <textarea
                  name="description"
                  id="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline outline-1 outline-gray-300 placeholder:text-gray-400 focus:outline-purple-800 sm:text-sm  dark:!bg-navy-700 dark:text-white"
                />
              </div>
            </div>
            

           
          </div>
          <hr className="mt-5 mb-5" />
          <div className="flex justify-center">
            <button
              type="button"
              onClick={handleUpdate}
              className="px-4 py-2 bg-purple-600 text-white rounded-md shadow hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-500"
            >
              Update
            </button>
          </div>
        </div>
      </div>
    
    </>
  )
}

export default TestimonialContent